<script setup>
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { Link } from '@inertiajs/vue3';
import { helperStore } from "@/store/helper"
const helper = helperStore()
import { onMounted, ref } from 'vue';
import axios from 'axios';

const services = ref([]);


async function getServiceSlider() {
    try {
        const res = await axios.get('/service-slider-data');
        services.value = res.data || []; // Assign response data or keep empty object
    } catch (error) {
        console.error('Error fetching service:', error);
    }
}

onMounted(() => {
    getServiceSlider();
})

</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 xl:py-12 py-4 mx-auto">
            <div class="flex flex-wrap bg-[#4BBFD1] rounded-xl wow animate__animated animate__fadeInLeft">
                <div class="lg:w-1/2 w-full relative lg:hidden block">
                    <div class="w-full 2xl:h-[490px] xl:h-[450px] lg:h-[380px] xl:-mt-12 -mt-10">
                        <VLazyImage src="/assets/images/daigonistic.png" alt="health-care-image"
                            class="h-full w-full object-cover object-center inline-block" />
                    </div>
                </div>
                <div class="lg:w-1/2 w-full mx-auto">
                    <el-carousel indicator-position="outside" arrow="hover" :interval="3000"
                        class="xl:h-[400px] lg:h-[330px] h-[250px] 2xl:py-20 py-0 px-0 ">
                        <el-carousel-item trigger="click" class="xl:py-4 lg:py-12 py-2 lg:px-16 px-8"
                            v-for="service in services" :key="service.id">
                            <h2
                                class="text-white title-font 2xl:text-[44px] xl:text-[42px] lg:text-[32px] text-[24px] lg:mb-2">
                                {{ locale === 'BN' ? service?.bn_title : service?.title }}</h2>
                            <p class="xl:text-lg text-base text-white leading-relaxed xl:mb-8 mb-4"
                                v-html="helper.textShort(locale === 'BN' ? service?.bn_content : service?.content, 170)">
                            </p>
                            <Link :href="route('service.page', service?.slug)" target="_balnk"
                                class="border text-[#1CBED1] hover:bg-[#1565C0] hover:border-transparent hover:text-white py-2 px-12 tracking-wider rounded-md shadow transition duration-300 font-semibold bg-white text-base">
                            {{ $t('nav.booking') }}</Link>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="lg:w-1/2 w-full relative lg:block hidden">
                    <div class="h-52 absolute top-20 left-5 lg:border-l border-gray-300"></div>
                    <div class="w-full 2xl:h-[490px] xl:h-[450px] lg:h-[380px] h-full xl:-mt-14 -mt-10">
                        <VLazyImage src="/assets/images/daigonistic.png" alt="health-care-image"
                            class="h-full w-full object-cover object-center inline-block" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
